export const SYNC_TIMEZONE = 'Asia/Kolkata';

export type ProfileSyncStatus = {
  lastSyncedAt: string | null;
  status: string;
  lastError: string | null;
  nextScheduledAt: string;
};

export function formatSyncTime(iso: string): string {
  return new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: SYNC_TIMEZONE,
    timeZoneName: 'short',
  }).format(new Date(iso));
}

export function describeSyncStatus(data: ProfileSyncStatus | undefined): string {
  if (!data) return '';
  if (data.status === 'running') return 'Syncing…';
  if (data.lastSyncedAt) {
    const base = `Last synced ${formatSyncTime(data.lastSyncedAt)}`;
    return data.status === 'failed' ? `${base} · failed` : base;
  }
  return 'Not synced yet';
}

export function describeFlipkartSyncStatus(syncedAt: string | null | undefined): string {
  if (!syncedAt) return 'Not synced yet';
  return `Last synced ${formatSyncTime(syncedAt)}`;
}
